<template>
	<section v-if="articles.length" class="related-articles" aria-labelledby="related-articles-title">
		<h2 id="related-articles-title">Related Articles</h2>
		<div class="related-grid">
			<a v-for="article in articles" :key="article.url" :href="article.url" class="related-card">
				<img :src="article.poster" :alt="article.title">
				<div class="related-card-body">
					<h3>{{ article.title }}</h3>
					<p v-if="article.date">{{ article.date }}</p>
				</div>
			</a>
		</div>
	</section>
</template>

<script>
import doc from '@/documents/blogs.js';

export default {
	name: 'RelatedArticles',
	props: {
		limit: {
			type: Number,
			default: 3,
		},
	},
	computed: {
		articles() {
			const currentPath = this.normalizePath(this.$route && this.$route.path);
			return doc.bloglist.en
				.filter((article) => this.normalizePath(article.url) !== currentPath)
				.slice(0, this.limit);
		},
	},
	methods: {
		normalizePath(path) {
			if (!path) return '/';
			return path.endsWith('/') ? path : `${path}/`;
		},
	},
};
</script>

<style lang="scss" scoped>
.related-articles {
	max-width: 1000px;
	margin: 42px auto 10px;
	padding-top: 28px;
	border-top: 1px solid #e8edf0;
}

.related-articles h2 {
	font-size: 1.5em;
	margin: 0 0 18px;
	color: #2d3748;
	border: 0;
	padding: 0;
	text-align: left;
}

.related-grid {
	display: grid;
	grid-template-columns: repeat(3, minmax(0, 1fr));
	gap: 18px;
}

.related-card {
	display: block;
	background: #fff;
	border: 1px solid #e8edf0;
	border-radius: 8px;
	overflow: hidden;
	text-decoration: none;
	color: inherit;
	transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.related-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 8px 18px rgba(16, 24, 40, 0.12);
}

.related-card img {
	width: 100%;
	aspect-ratio: 16 / 9;
	object-fit: cover;
	display: block;
	margin: 0;
	border-radius: 0;
}

.related-card-body {
	padding: 14px;
}

.related-card h3 {
	font-size: 16px;
	line-height: 1.35;
	margin: 0;
	color: #1f2937;
}

.related-card p {
	margin: 8px 0 0;
	font-size: 13px;
	color: #667085;
}

@media (max-width: 768px) {
	.related-grid {
		grid-template-columns: 1fr;
	}
}
</style>
